<template>
  <div>
    <div>
      <el-form :model="form" ref="form" label-width="120px" :hide-required-asterisk="true">
        <div @keyup.enter.stop="save()">
          <el-form-item label="考级点名称" prop="agentName" :rules="[$validate.string(50)]">
            <el-input v-model="form.agentName" placeholder="请输入考级点名称"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="userName" :rules="[$validate.string(50)]">
            <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone" :rules="[$validate.mobile()]">
            <el-input v-model="form.phone" :maxlength="11" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="报名类型" prop="enrollType">
            <el-select v-model="form.enrollType">
              <el-option v-for="(item,index) in Tool.map2arr($enums.isLine)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地" prop="parentAddress">
            <el-cascader v-model="form.address" :options="areaTreeData" :props="{value:'areaId',label:'areaName',emitPath:true}" @change="handleChange"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="addressDetail" :rules="[$validate.string(200)]">
            <el-input v-model="form.addressDetail" :maxlength="200" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['agentId'],
  data () {
    return {
      form: {},
      areaTreeData: [],
      address: ''
    }
  },
  async created () {
    this.areaTreeData = await this.$HTTP.ApiCommon.getAreaTreeData()
    console.log(this.areaTreeData);
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.agentId) {
        let info = await this.$HTTP.ApiAgent.getAgentDetail(this.agentId)
        // info.receiverAddressInfo2 = info.receiverAddressInfo ? info.receiverAddressInfo.split('/') : []
        this.form = info
      }
      this.$forceUpdate()
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async handleChange (value) {
      this.address = value[1]
    },
    async save () {
      try {
        let isOK = await this.Tool.checkForm(this.$refs['form'])
        if (isOK) {
          if (this.agentId) {
            if (this.address) {
              // this.$set(this.form, 'parentAddress', this.form.address[0])
              this.$set(this.form, 'parentAddress', this.form.address[0])
              this.form.address = this.form.address[1]
            } else {
              this.form.address = this.form.address
              this.form.parentAddress = this.form.parentAddress
            }
            await this.$HTTP.ApiAgent.getAgentUpdate(this.form)
            this.$message({ type: 'success', message: '修改成功' })
            this.$emit('close', false)
          } else {
            if (this.form.parentAddress) {
              this.form.parentAddress = this.form.parentAddress
            } else {
              this.$set(this.form, 'parentAddress', this.form.address[0])
            }
            this.form.address = this.address
            await this.$HTTP.ApiAgent.getAgentAdd(this.form)
            this.$message({ type: 'success', message: '添加成功' })
            this.$emit('close', false)
          }
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
